// import Reflux from 'reflux'
import React from 'react'
import Reflux from 'reflux'
// import { Alert } from 'reactstrap'
// import { Container, Row, Col, Alert, Button } from 'reactstrap'
// import { Container, Row, Col, Alert } from 'reactstrap'
// import { Alert, Button } from 'reactstrap'
import { HashRouter as Router, Switch, Route } from 'react-router-dom'
import { NotificationContainer } from 'react-notifications'

import ModalQuantities from '~/modules/modals/quantities.jsx'
import ModalIngredients from '~/modules/modals/ingredients.jsx'
import ModalIngredientsTypes from '~/modules/modals/ingredientsTypes.jsx'

import RecipesStore from '~/stores/recipes.js'

// import AuthStore from '~/stores/auth.js'
// import AuthActions from '~/actions/auth.js'
// import OnlyIfAuthorized from '~/modules/onlyIfAuthorized/index.jsx'
import Headerbar from '../layout/headerbar.jsx'
// import NavMenu from '../navbar/index.jsx'
import RecipeList from '../list/index.jsx'
import RecipeDetails from '../details/index.jsx'
import RecipeEdit from '../details/edit.jsx'
import ShoppingList from '../shoppingList/index.jsx'
import Login from '../login/index.jsx'


export default class App extends React.Component {
// export default class App extends Reflux.Component {
	constructor(props) {
		super(props)

		// store subscriptions
		// this.store = AuthStore
		// this.storeKeys = ['authenticated', 'username']
		Reflux.initStore(RecipesStore)
	}

	// ********************************************************************************
	// ********************************************************************************

	dspUncategorized = () => <RecipeList categoryID={1} />

	dspBreakfasts = () => <RecipeList categoryID={2} />
	dspBeverages = () => <RecipeList categoryID={3} />
	dspAppetizers = () => <RecipeList categoryID={4} />
	dspSoups = () => <RecipeList categoryID={5} />
	dspSalads = () => <RecipeList categoryID={6} />
	dspMainBeef = () => <RecipeList categoryID={7} />
	dspMainPoultry = () => <RecipeList categoryID={8} />
	dspMainPork = () => <RecipeList categoryID={9} />
	dspMainSeafood = () => <RecipeList categoryID={10} />
	dspMainVegetarian = () => <RecipeList categoryID={11} />
	dspMainVegetables = () => <RecipeList categoryID={12} />
	dspSidesVegetables = () => <RecipeList categoryID={13} />
	dspSidesVegetarian = () => <RecipeList categoryID={14} />
	dspDesserts = () => <RecipeList categoryID={15} />
	dspCanningFreezing = () => <RecipeList categoryID={16} />
	dspBreads = () => <RecipeList categoryID={17} />

	// ********************************************************************************
	// ********************************************************************************

	render() {
		return (
			<Router>
				<div className="app">
					<ModalQuantities />
					<ModalIngredients />
					<ModalIngredientsTypes />

					<Headerbar />

					<Login />

					{/*
					<OnlyIfAuthorized>
						<Container fluid>
							<Row>
								<Col>
									<Alert color="info">
										You are currently logged in as { this.state.username }
									</Alert>
								</Col>
							</Row>
						</Container>
					</OnlyIfAuthorized>
					*/}

					<Switch>
						<Route path="/" component={RecipeList} exact />

						<Route path="/breakfasts" render={this.dspBreakfasts} />
						<Route path="/appetizers" render={this.dspAppetizers} />
						<Route path="/soups" render={this.dspSoups} />
						<Route path="/salads" render={this.dspSalads} />
						<Route path="/breads" render={this.dspBreads} />

						<Route path="/main-dishes/beef" render={this.dspMainBeef} />
						<Route path="/main-dishes/pork" render={this.dspMainPork} />
						<Route path="/main-dishes/poultry" render={this.dspMainPoultry} />
						<Route path="/main-dishes/seafood" render={this.dspMainSeafood} />
						<Route path="/main-dishes/vegetables" render={this.dspMainVegetables} />
						<Route path="/main-dishes/vegetarian" render={this.dspMainVegetarian} />

						<Route path="/side-dishes/vegetables" render={this.dspSidesVegetables} />
						<Route path="/side-dishes/vegetarian" render={this.dspSidesVegetarian} />

						<Route path="/desserts" render={this.dspDesserts} />
						<Route path="/beverages" render={this.dspBeverages} />
						<Route path="/canningFreezing" render={this.dspCanningFreezing} />
						<Route path="/uncategorized" render={this.dspUncategorized} />

						<Route path="/shopping" component={ShoppingList} />

						<Route path="/recipe/:recipeID" component={RecipeDetails} exact />

						<Route path="/recipe/:recipeID/edit" component={RecipeEdit} />
					</Switch>

					<NotificationContainer />
				</div>
			</Router>
		)
	}
}



// WEBPACK FOOTER //
// ./src/modules/App/index.js